<div class="admin-bar">Admin</div>
<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="page">
  <div class="container">
    <div class="header-row">
      <h1>{{ isEditMode ? 'Editar permissões do usuário' : 'Nova atribuição de permissões' }}</h1>
      <div class="header-actions">
        <!-- <button mat-stroked-button (click)="goBack()">
          <mat-icon>arrow_back</mat-icon>
          Voltar
        </button> -->
      </div>
    </div>

    <ng-container *ngIf="isLoading; else formTpl">
      <div class="spinner">
        <mat-progress-spinner mode="indeterminate" diameter="56"></mat-progress-spinner>
      </div>
    </ng-container>

    <ng-template #formTpl>
      <form [formGroup]="form" class="form">
        <!-- Usuário -->
        <div class="field">
          <label class="label">Usuário</label>

          <!-- Modo edição com idUser pré-selecionado -->
          <div *ngIf="selectedUser; else userPickerTpl" class="selected-user">
            <div class="user-badge">
              <div class="name">{{ selectedUser.userName }}</div>
              <div class="email">{{ selectedUser.userEmail }}</div>
            </div>
            <button mat-button type="button" (click)="clearUser()" [disabled]="lockUserSelect">
              <mat-icon>close</mat-icon> Trocar usuário
            </button>
          </div>

          <!-- Seletor de usuário ativo -->
          <ng-template #userPickerTpl>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Buscar usuário ativo</mat-label>
              <input matInput
                     type="text"
                     [matAutocomplete]="auto"
                     [value]="userSearch"
                     (input)="onUserSearch($any($event.target).value || '')"
                     [disabled]="lockUserSelect"/>
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onUserSelected($event.option.value)">
                <mat-option *ngFor="let u of filteredUsers; trackBy: trackByUser" [value]="u">
                  {{ u.userName }} — {{ u.userEmail }}
                </mat-option>
                <mat-option *ngIf="filteredUsers.length === 0" disabled>Nenhum usuário encontrado</mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </ng-template>
        </div>

        <!-- Permissões -->
        <div class="field">
          <label class="label">Permissões</label>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Adicionar permissões</mat-label>
            <mat-select [disabled]="!selectedUser" (selectionChange)="onAddPermission($event.value)">
              <mat-option *ngFor="let p of permissionOptions; trackBy: trackByPermission" [value]="p">
                {{ p.permissionName }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="chips">
            <div *ngFor="let p of selectedPermissions; trackBy: trackByPermissionId" class="chip">
              <span class="chip-text" [matTooltip]="p.permissionDescription">{{ p.permissionName }}</span>
              <button type="button" mat-icon-button (click)="removePermission(p)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <div *ngIf="selectedPermissions.length === 0" class="hint">Nenhuma permissão selecionada.</div>
          </div>
        </div>

        <!-- Ações -->
        <div class="actions">
        <button mat-stroked-button (click)="goBack()">
          <mat-icon>arrow_back</mat-icon>
          Voltar
        </button>
          <button mat-raised-button class="btn-primary button-login" (click)="save()" [disabled]="!canSave()">
            <mat-icon>save</mat-icon> Salvar
          </button>

          <!-- <button *ngIf="isEditMode" mat-stroked-button color="warn" type="button" (click)="deleteAll()">
            <mat-icon>delete</mat-icon> Remover todas as permissões
          </button> -->
        </div>
      </form>
    </ng-template>
  </div>
</div>

<app-footer></app-footer>
